// extracted by mini-css-extract-plugin
module.exports = {"details":"Details-module--details--2_O3i","balance":"Details-module--balance--StKKg","actions":"Details-module--actions--3mn04"};